<template>
  <ul
    :class="[
      'o-file-list',
      'el-upload-list',
      'el-upload-list--' + listType,
      { 'is-disabled': disabled }
    ]"
  >
    <li
      v-for="(file, fileId) in filesObj"
      :key="fileId"
      :class="['el-upload-list__item', 'is-' + file.status, focusing ? 'focusing' : '']"
      tabindex="0"
      @keydown.delete="handleKeydownDelete(file)"
      @focus="focusing = true"
      @blur="focusing = false"
      @click="focusing = false"
    >
      <slot :file="filesObj[fileId]">
        <img
          v-if="file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(listType) > -1"
          class="el-upload-list__item-thumbnail"
          :src="file.url"
          alt=""
        >
        <a
          class="el-upload-list__item-name"
          @click="handleClick(file)"
        >
          <i
            v-if="!disabled"
            class="el-icon-delete u-text-danger"
            @click.stop="handleRemoveFile(file)"
          />
          <i class="el-icon-document" />
          {{ file.name || fileId }}
        </a>
        <label class="el-upload-list__item-status-label">
          <i
            :class="{
              'el-icon-upload-success': true,
              'el-icon-circle-check': listType === 'text',
              'el-icon-check': ['picture-card', 'picture'].indexOf(listType) > -1
            }"
          />
        </label>
        <i
          v-if="!disabled"
          class="el-icon-close"
          @click="handleRemoveFile(file)"
        />
        <i
          v-if="!disabled"
          class="el-icon-close-tip"
        >
          按 delete 键可删除
        </i>
        <!--因为close按钮只在li:focus的时候 display, li blur后就不存在了，所以键盘导航时永远无法 focus到 close按钮上-->
        <el-progress
          v-if="file.status === 'uploading'"
          :type="listType === 'picture-card' ? 'circle' : 'line'"
          :stroke-width="listType === 'picture-card' ? 6 : 2"
          :percentage="parsePercentage(file.percentage)"
        />
        <span
          v-if="listType === 'picture-card'"
          :class="{'el-upload-list__item-actions':edit}"
        >
          <span
            v-if="handlePreview && listType === 'picture-card'"
            class="el-upload-list__item-preview"
            @click="handlePreview(file)"
          >
            <i class="el-icon-zoom-in" />
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemoveFile(file)"
          >
            <i class="el-icon-delete" />
          </span>
        </span>
      </slot>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ImageUploadList',
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    files: {
      type: Array,
      default () {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    handlePreview: Function,
    listType: {
      type: String,
      default: 'text'
    },
    edit: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      focusing: false,
      imageApi: this.$config.ctx.iffApi + '/common/image',
      initDownloadApi: this.$config.fileApi.initDownload,
      downloadApi: this.$config.fileApi.download,
      filesObj: {}
    };
  },
  methods: {
    parsePercentage (val) {
      return parseInt(val, 10);
    },
    handleClick (file) {
      const _this = this;
      if (_this.handlePreview) {
        _this.handlePreview(file);
      } else {
        _this.initDownload(file.fileId)
          .then((rsp) => {
            const filePath = rsp.data.data;
            _this.$axios.get(`${_this.downloadApi}/${filePath}`, { responseType: 'blob' })
              .then((res) => {
                const fileStream = res.data;
                // 读取文件名
                const fileName = decodeURIComponent(escape(res.headers['content-disposition'].split('=')[1]));
                _this.$HMUtil.downloadStreamFile(fileStream, fileName);
              })
              .catch((err) => {
                console.error('下载文件失败！', err);
              });
          })
          .catch((err) => {
            console.error('初始化下载文件失败！', err);
          });
      }
    },
    /**
     * @description: 初始化下载
     * @param {*} fileId
     * @return {*}
     */
    initDownload (fileId) {
      return this.$axios.get(`${this.initDownloadApi}/${fileId}`);
    },
    handleKeydownDelete (file) {
      this.disabled = !this.disabled;
      // this.$emit('remove', file);
      delete this.filesObj[file.fileId];
      this.getFileValue();
    },
    handleRemoveFile (file) {
      // this.$emit('remove', file);
      delete this.filesObj[file.fileId];
      this.getFileValue();
    },
    getFileValue () {
      const fileIds = Object.keys(this.filesObj);
      if (this.multiple) {
        this.$emit('input', fileIds);
      } else {
        this.$emit('input', '');
      }
    },
    /**
     * @description: 根据绑定的value，迭代初始化文件信息
     * @return {*}
     */
    handleIterationInitFile () {
      const _this = this;
      if (_this.multiple) {
        _this.value.forEach(item => {
          _this.$set(_this.filesObj, item, {
            fileId: item
          });
          _this.initFile(item);
        });
      } else {
        _this.initFile(_this.value);
      }
      console.log(this.filesObj);
    },
    /**
     * @description: 初始化获取文件信息
     * @param {*} fileId
     * @return {*}
     */
    initFile (fileId) {
      this.$axios.get(`${this.imageApi}/${fileId}`)
        .then(rsp => {
          this.$set(this.filesObj, fileId, {
            ...this.filesObj[fileId],
            fileId: rsp.data.id || fileId,
            url: 'data:image/png;base64,' + rsp.data.data,
            status: 'success'
          });
        })
        .catch(err => {
          console.error('文件信息加载失败：' + fileId, err);
        });
    }
  },
  watch: {
    value: {
      handler (newValue, oldValue) {
        if (newValue && newValue.length > 0 && (!oldValue || oldValue.length === 0)) {
          this.handleIterationInitFile();
        } else if (this.multiple && newValue && newValue.length > oldValue.length) {
          const fileId = newValue[newValue.length - 1];
          this.$set(this.filesObj, fileId, {
            fileId: fileId
          });
          this.initFile(fileId);
        }
      },
      deep: true
    }
  },
  created () {
    if (this.value && this.value.length > 0) {
      this.handleIterationInitFile();
    }
  }
};
</script>
